import API from './API.js'

export default class Program_lists extends API {
  constructor() {
    super('program_lists')
  }
}
